module.exports = __webpack_public_path__ + "img/Niger.8b030478.svg";